// extracted by mini-css-extract-plugin
module.exports = {"item":"sideBar-module--item--VBnbL","active":"sideBar-module--active--3RGOc","expanded":"sideBar-module--expanded--27MNy","subItems":"sideBar-module--subItems--2wzzD"};